// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".refuse-dialog .el-dialog__body{padding:20px 20px 10px}.refuse-dialog .el-dialog__body .text{margin-bottom:10px}.special-message .el-message-box__btns .el-button{border:none;color:#fff;background-color:#00aea5}.special-message .el-message-box__btns .el-button--primary{background-color:#fe674c}", ""]);
// Exports
module.exports = exports;
